import { Injectable, inject } from '@angular/core';
import { ComponentStoreFactory } from '../../../../../shared/store/common/component-store.factory';
import { Store } from '@ngrx/store';
import { WorkplaceService } from '../../../../../../services/workplace.service';
import { selectCurrentService } from '../../../../store/person/person.selectors';
import { map } from 'rxjs/operators';

interface State {
}

const defaultState: State = {};

@Injectable()
export class EditWorkplaceModalStore extends ComponentStoreFactory<State> {

    public workplaces$ = this.globalStore!.select(selectCurrentService).pipe(map((it) => it?.workplaces || []));

    constructor() {
        super(defaultState, inject(Store), inject(WorkplaceService));
    }

}
